import useMasterData from "./useMasterData";

export const useUserFilterActions = () => {

  const { filterMapData: rawActions } = useMasterData();
  const userFilterActions = rawActions || [];

  const uniqueByKey = <T>(
    arr: T[],
    idKey: keyof T,
    nameKey: keyof T
  ) => {
    const map = new Map<number, { id: number; name: string }>();

    arr.forEach((item: any) => {
      const id = Number(item[idKey]);
      if (!map.has(id)) {
        map.set(id, {
          id,
          name: String(item[nameKey]),
        });
      }
    });

    return Array.from(map.values());
  };

  const ORG_ID = 1;

  const getFilteredData = (filters: { regionIds?: number[] | null }) => {
    if (!userFilterActions.length) {
      return { regions: [], workstreams: [] };
    }

    const orgFiltered = userFilterActions.filter(
      (x: any) => Number(x.org_id) === ORG_ID
    );

    return {
      regions: uniqueByKey(
        orgFiltered,
        'region_id',
        'region_name'
      ),
      workstreams: uniqueByKey(
        filters?.regionIds?.length
          ? orgFiltered.filter((x: any) =>
            filters.regionIds!.includes(Number(x.region_id))
          )
          : orgFiltered,
        'workstream_id',
        'workstream_name'
      ),
    };
  };

  const cleanFilters = (
    updated: any,
    changedKey: "region" | "workstream",
    actions = userFilterActions
  ) => {
    if (!actions.length) return updated;

    const cleaned = { ...updated };
    const { region, workstream } = cleaned;

    const validRecords = actions.filter((x: { org_id: number; region_id: any; workstream_id: any; }) => {
      const matchOrg = x.org_id === ORG_ID;
      const matchRegion =
        !region.length || region.includes(x.region_id);
      const matchWorkstream =
        !workstream.length || workstream.includes(x.workstream_id);

      return matchOrg && matchRegion && matchWorkstream;
    });

    const validWorkstreamIds = validRecords.map(
      (x: { workstream_id: any; }) => x.workstream_id
    );

    if (changedKey === "region") {
      cleaned.workstream = workstream.filter((id: number) =>
        validWorkstreamIds.includes(id)
      );
    }

    return cleaned;
  };

  const cleanSingleFormFilters = (
    updated: any,
    changedKey: "region",
    actions = userFilterActions
  ) => {
    if (!actions.length) return updated;

    const cleaned = { ...updated };
    const { region, workstream } = cleaned;

    const validRecords = actions.filter((x: { org_id: number; region_id: any; workstream_id: any; }) => {
      const matchOrg = x.org_id === ORG_ID;
      const matchRegion = !region || x.region_id === region;
      const matchWorkstream =
        !workstream || x.workstream_id === workstream;

      return matchOrg && matchRegion && matchWorkstream;
    });

    if (
      cleaned.workstream &&
      !validRecords.some(
        (x: { workstream_id: any; }) => x.workstream_id === cleaned.workstream
      )
    ) {
      cleaned.workstream = "";
    }

    return cleaned;
  };

  return {
    userFilterActions,
    getFilteredData,
    cleanFilters,
    cleanSingleFormFilters,
  };
};